import { c as _c } from "react/compiler-runtime";
import { MenuItem } from "@flat-ui";
import { FilterChipDropdownItem } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-item";
import { FilterChipSearch } from "@components/common/faro-table/faro-table-filter/filter-chip-search";
import { useMemo, useState } from "react";
/**
 * The items of a filter chip dropdown, optionally with a search box above them. It is shown inside
 * the menu of the chip, so it can be shared by chips that show more than a list in their menu.
 */
export function FilterChipDropdownList(t0) {
  const $ = _c(22);
  const {
    label,
    items,
    activeFilterIds,
    shouldShowSearchBox,
    shouldShowCheckbox,
    shouldShowCheckIconOnRight: t1,
    shouldAllowLabelTranslation: t2,
    isLoading: t3,
    onItemClicked,
    onEscape
  } = t0;
  const shouldShowCheckIconOnRight = t1 === undefined ? false : t1;
  const shouldAllowLabelTranslation = t2 === undefined ? false : t2;
  const isLoading = t3 === undefined ? false : t3;
  const [searchText, setSearchText] = useState("");
  let t4;
  if ($[0] !== items || $[1] !== searchText) {
    const search = searchText.trim().toLowerCase();
    t4 = Object.values(items).filter(item => [item.label, ...(item.searchTerms ?? [])].some(value => value.toLowerCase().includes(search)));
    $[0] = items;
    $[1] = searchText;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const filterItems = t4;
  let t5;
  if ($[3] !== onEscape || $[4] !== searchText || $[5] !== shouldShowSearchBox) {
    t5 = shouldShowSearchBox && <FilterChipSearch searchText={searchText} setSearchText={setSearchText} onEscape={() => {
      onEscape();
      setSearchText("");
    }} />;
    $[3] = onEscape;
    $[4] = searchText;
    $[5] = shouldShowSearchBox;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== activeFilterIds || $[8] !== filterItems || $[9] !== onItemClicked || $[10] !== shouldAllowLabelTranslation || $[11] !== shouldShowCheckIconOnRight || $[12] !== shouldShowCheckbox) {
    t6 = filterItems.map(item_0 => <FilterChipDropdownItem key={item_0.id} filterItem={item_0} isItemSelected={activeFilterIds.includes(item_0.id)} onItemClicked={filterId => {
      onItemClicked(filterId);
      setSearchText("");
    }} shouldShowCheckbox={shouldShowCheckbox} shouldShowCheckIconOnRight={shouldShowCheckIconOnRight} shouldAllowLabelTranslation={shouldAllowLabelTranslation} />);
    $[7] = activeFilterIds;
    $[8] = filterItems;
    $[9] = onItemClicked;
    $[10] = shouldAllowLabelTranslation;
    $[11] = shouldShowCheckIconOnRight;
    $[12] = shouldShowCheckbox;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== filterItems.length || $[15] !== isLoading || $[16] !== label) {
    t7 = (isLoading || filterItems.length === 0) && <MenuItem label={isLoading ? `Loading the ${label.toLowerCase()}...` : `No ${label.toLowerCase()} found!`} sx={{
      pointerEvents: "none",
      textWrap: "wrap"
    }} />;
    $[14] = filterItems.length;
    $[15] = isLoading;
    $[16] = label;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <>{t5}{t6}{t7}</>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}